import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import FieldLabel, { mapPlacement } from '../FieldLabel';
import Checkbox from '../Checkbox';
var CheckboxElement = styled(Checkbox).withConfig({
  displayName: "ui-kit-CheckboxElement",
  componentId: "ui-kit-1xx4g71"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.placementRight {\n    margin-right: 4px;\n  }\n\n  &.placementLeft {\n    margin-left: 4px\n  }\n"], ["\n  &.placementRight {\n    margin-right: 4px;\n  }\n\n  &.placementLeft {\n    margin-left: 4px\n  }\n"])));
var CheckboxField = React.forwardRef(function (_a, ref) {
  var label = _a.label,
      _b = _a.labelPlacement,
      labelPlacement = _b === void 0 ? 'right' : _b,
      disableTypography = _a.disableTypography,
      typographyProps = _a.typographyProps,
      className = _a.className,
      disabled = _a.disabled,
      props = __rest(_a, ["label", "labelPlacement", "disableTypography", "typographyProps", "className", "disabled"]);

  return _jsx(FieldLabel, __assign({
    className: className,
    label: label,
    placement: labelPlacement,
    disableTypography: disableTypography,
    disabled: disabled,
    typographyProps: typographyProps
  }, {
    children: _jsx(CheckboxElement, __assign({
      disabled: disabled,
      className: classnames('ui-checkbox-field__input', Boolean(label) && mapPlacement(labelPlacement)),
      ref: ref
    }, props))
  }));
});
export default React.memo(CheckboxField);
var templateObject_1;